import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

import { isIntlDiff } from '@/utils/isValidIntl';

import { addressStyles as sx } from './Address.styles';

export const AddressLine = ({
	primary,
	intl,
	showIntl
}: {
	primary?: string | null;
	intl?: string | null;
	showIntl: boolean;
}) => {
	if (!primary) return null;
	const shouldShowIntl = isIntlDiff(primary, intl ?? '');

	return (
		<Typography sx={sx.line}>
			{primary}
			{showIntl && intl && shouldShowIntl && (
				<Box component='span' sx={sx.intlSuffix}>
					({intl})
				</Box>
			)}
		</Typography>
	);
};
